import axiosClient from './axiosClient';
import store from '../reducers/store';
import { setUser } from '../reducers/userReducer';
import { deleteToken, saveToken } from '../login/localStorage';
import { AxiosRequestConfig } from 'axios';
import { UserDTO } from '@envclient/envcore';

const endpoint = 'user';

const loginWithFb = (token: string) => {
  console.log('loginWithFb', token);
  const requestConfig: AxiosRequestConfig = {
    url: `${endpoint}/login/fb`,
    method: 'post',
    data: {
      token
    },
    withCredentials: false
  };
  return axiosClient
    .request(requestConfig)
    .then((response) => {
      saveToken(response.data.token);
      return response;
    })
    .catch((error) => {
      deleteToken();
      console.log('FB login error', error);
      return Promise.reject(error);
    });
};

const loginWithGoogle = (token: string) => {
  console.log('loginWithGoogle', token);
  const requestConfig: AxiosRequestConfig = {
    url: `${endpoint}/login/google`,
    method: 'post',
    data: {
      token
    },
    withCredentials: false
  };
  return axiosClient
    .request(requestConfig)
    .then((response) => {
      saveToken(response.data.token);
      return response;
    })
    .catch((error) => {
      deleteToken();
      console.log('Google login error', error);
      return Promise.reject(error);
    });
};

const loginWithApple = (token: string, userName: string) => {
  console.log('loginWithApple', token);
  const requestConfig: AxiosRequestConfig = {
    url: `${endpoint}/login/apple`,
    method: 'post',
    data: {
      token,
      userName
    },
    withCredentials: false
  };
  return axiosClient
    .request(requestConfig)
    .then((response) => {
      saveToken(response.data.token);
      return response;
    })
    .catch((error) => {
      deleteToken();
      console.log('Apple login error', error);
      return Promise.reject(error);
    });
};

const getUserInfo = (): Promise<UserDTO> => {
  const requestConfig: AxiosRequestConfig = {
    url: `${endpoint}/me`,
    method: 'get',
    withCredentials: true
  };
  return axiosClient.request(requestConfig).then((response) => {
    store.dispatch(setUser(response.data.user));
    // lets the server hand new page-loads a different WS instance/path (e.g. during a rolling
    // envengine deploy) without touching clients already connected mid-game. Falls back to the
    // bundled default when unset, so this stays a no-op until WS_URL is actually configured.
    const wsUrl = response.data.config?.wsUrl;
    if (wsUrl) window.runtimeConfig.REACT_APP_WS_URL = wsUrl;
    return response.data.user;
  });
};

const convertPoints = (): Promise<void> => {
  const requestConfig: AxiosRequestConfig = {
    url: `${endpoint}/convert`,
    method: 'post'
  };
  return axiosClient.request(requestConfig);
};

const signUp = (email: string, password: string, username: string): Promise<{ message: string }> => {
  const requestConfig: AxiosRequestConfig = {
    url: `${endpoint}/signup`,
    method: 'post',
    data: { email, password, username }
  };
  return axiosClient.request(requestConfig).then((r) => r.data);
};

const loginWithEmail = (email: string, password: string) => {
  const requestConfig: AxiosRequestConfig = {
    url: `${endpoint}/login/email`,
    method: 'post',
    data: { email, password }
  };
  return axiosClient
    .request(requestConfig)
    .then((response) => {
      saveToken(response.data.token);
      return response;
    })
    .catch((error) => {
      deleteToken();
      console.log('Email login error', error);
      return Promise.reject(error);
    });
};

const loginWithGuest = (name?: string) => {
  const requestConfig: AxiosRequestConfig = {
    url: `${endpoint}/login/guest`,
    method: 'post',
    data: { name }
  };
  return axiosClient
    .request(requestConfig)
    .then((response) => {
      saveToken(response.data.token);
      return response;
    })
    .catch((error) => {
      deleteToken();
      console.log('Guest login error', error);
      return Promise.reject(error);
    });
};

export {
  loginWithFb,
  loginWithGoogle,
  getUserInfo,
  convertPoints,
  loginWithApple,
  signUp,
  loginWithEmail,
  loginWithGuest
};
